// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_page__5BEPx {
    /*display: flex;*/
    grid-gap: 20px;
    justify-content: center;
    /*align-items: flex-start;*/
    margin: 0 auto;
    max-width: 100%;
    /*width: 1890px;*/
    width: 2170px;
    padding: 24px 30px 34px;
}

.styles_pageSimple__CL1qe {
    display: flex;
}

.styles_content__uutki {
    width: 1100px;
    max-width: calc(100vw - 450px);
}

.styles_flex__S8cIN {
    flex: 1 1;
}

.styles_navigation__5bU9Y {
    margin: auto 0;
}

.styles_formSeparator__q7aq5 {
    background: 0;
    height: 0;
    border: 0;
    border-bottom: 1px dashed var(--primary-color);
    margin: 23px calc(var(--padding-x) * -1) 36px;
    width: calc(100% + var(--padding-x) * 2);
}

.styles_formSemiHeader__aoomM {
    color: #7b848e;
    margin-top: 20px;
    margin-bottom: 26px;
    font-size: 10px;
    font-weight: bold;
    text-transform: uppercase;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    .styles_page__5BEPx {
        grid-gap: 35px;
        margin: 0 auto;
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .styles_navigation__5bU9Y {
        display: none;
    }

    .styles_margin__Mq4cm {
        margin: 0 auto;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Storage/StorageForm/styles.module.css"],"names":[],"mappings":"AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,uBAAuB;IACvB,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,SAAS;IACT,8CAA8C;IAC9C,6CAA6C;IAC7C,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI;QACI,cAAc;QACd,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":["@value screen-lg-min, screen-md-max from '../../../breakpoints.css';\n\n.page {\n    /*display: flex;*/\n    grid-gap: 20px;\n    justify-content: center;\n    /*align-items: flex-start;*/\n    margin: 0 auto;\n    max-width: 100%;\n    /*width: 1890px;*/\n    width: 2170px;\n    padding: 24px 30px 34px;\n}\n\n.pageSimple {\n    display: flex;\n}\n\n.content {\n    width: 1100px;\n    max-width: calc(100vw - 450px);\n}\n\n.flex {\n    flex: 1;\n}\n\n.navigation {\n    margin: auto 0;\n}\n\n.formSeparator {\n    background: 0;\n    height: 0;\n    border: 0;\n    border-bottom: 1px dashed var(--primary-color);\n    margin: 23px calc(var(--padding-x) * -1) 36px;\n    width: calc(100% + var(--padding-x) * 2);\n}\n\n.formSemiHeader {\n    color: #7b848e;\n    margin-top: 20px;\n    margin-bottom: 26px;\n    font-size: 10px;\n    font-weight: bold;\n    text-transform: uppercase;\n}\n\n@media screen-lg-min {\n    .page {\n        grid-gap: 35px;\n        margin: 0 auto;\n    }\n}\n\n@media screen-md-max {\n    .navigation {\n        display: none;\n    }\n\n    .margin {\n        margin: 0 auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"page": `styles_page__5BEPx`,
	"pageSimple": `styles_pageSimple__CL1qe`,
	"content": `styles_content__uutki`,
	"flex": `styles_flex__S8cIN`,
	"navigation": `styles_navigation__5bU9Y`,
	"formSeparator": `styles_formSeparator__q7aq5`,
	"formSemiHeader": `styles_formSemiHeader__aoomM`,
	"margin": `styles_margin__Mq4cm`
};
export default ___CSS_LOADER_EXPORT___;
